import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import PageContainer from './PageContainer';

import coverImage from './images/menu.jpg';

function PageMenu() {
	return (
	<PageContainer header='Menu' header_variant='h3' header_image={coverImage} header_image_position={45}>
        <Box sx={{textAlign:'center'}}>
        <Typography sx={{mb:2}}>
            Menumme päivittyy jatkuvasti, sillä olemme vielä uusi kahvila ja haluamme tarjota asiakkaillemme jatkuvasti uusia makuelämyksiä.
        </Typography>
        <Typography sx={{mb:2}}>
            Tavoitteenamme on tarjota laadukkaita ja herkullisia kahveja, kaakaota, teelaatuja sekä leivonnaisia ja suolaisia herkkuja, jotka täydentävät rentoja kahvilahetkiä kissojen seurassa.
        </Typography>
        <Typography sx={{mb:2}}>
            Kakkumme valmistetaan pääosin gluteenittomista jauhoista, ja teemme aktiivisesti töitä vegaanisten reseptien lisäämiseksi valikoimaamme. Päivittäinen ruokalistamme saattaa vaihdella, joten seuraamalla meitä sosiaalisessa mediassa pysyt ajan tasalla kaikista tuoreista herkuistamme ja muista jännittävistä uutisista!
        </Typography>
        <Typography sx={{mb:2}}>
            Toivomme, että menumme tuo iloa sekä makunystyröille että mielelle. Odotamme innolla, että pääsemme tarjoilemaan sinulle kahvilamme ensimmäiset herkut!
        </Typography>
        </Box>
	</PageContainer>
    );
}

export default PageMenu;